import TrialClass from "./TrialClass";

export default TrialClass;
